import { deselectAllBreadcrumbs } from '../../../features/breadcrumb/breadcrumb-actions.js';
import { buildController, } from '../../controller/headless-controller.js';
export const getBreadcrumbs = (config) => {
    return Object.keys(config.facetSet)
        .map((facetId) => {
        const values = config
            .facetValuesSelector(config.engine.state, facetId)
            .map((selection) => ({
            value: selection,
            deselect: () => {
                if (selection.state === 'selected') {
                    config.executeToggleSelect({ facetId, selection });
                }
                else if (selection.state === 'excluded') {
                    config.executeToggleExclude({ facetId, selection });
                }
            },
        }));
        return {
            facetId,
            field: config.facetSet[facetId].request.field,
            values,
        };
    })
        .filter((breadcrumb) => breadcrumb.values.length);
};
/**
 * Creates a `BreadcrumbManager` controller instance.
 *
 * @param engine - The headless engine.
 * @returns A `BreadcrumbManager` controller instance.
 */
export function buildCoreBreadcrumbManager(engine) {
    const controller = buildController(engine);
    const { dispatch } = engine;
    return {
        ...controller,
        get state() {
            return {
                facetBreadcrumbs: [],
                categoryFacetBreadcrumbs: [],
                numericFacetBreadcrumbs: [],
                dateFacetBreadcrumbs: [],
                staticFilterBreadcrumbs: [],
                hasBreadcrumbs: false,
            };
        },
        deselectAll: () => {
            dispatch(deselectAllBreadcrumbs());
        },
        deselectBreadcrumb(value) {
            value.deselect();
        },
    };
}
